import { render, staticRenderFns } from "./StatisticsPage.vue?vue&type=template&id=a28fbba2&scoped=true"
import script from "./StatisticsPage.vue?vue&type=script&lang=js"
export * from "./StatisticsPage.vue?vue&type=script&lang=js"
import style0 from "./StatisticsPage.vue?vue&type=style&index=0&id=a28fbba2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28fbba2",
  null
  
)

export default component.exports